module.exports = __webpack_public_path__ + "img/sj_gangtiewuliu.8089a110.jpg";